import { Box } from "@mui/material"
import { useTranslation } from "react-i18next"
import { visuallyHiddenSx } from "styles/common/typography"
import { IDashboardBehaviorRow } from "ts/interfaces/AdminDashboard"

import { getBehaviorTrend } from "./behaviorFormat"

// Inherits its type style, so the list and the focus card each set their own.
const BehaviorTrend = ({ row }: { row: IDashboardBehaviorRow }) => {
  const { t } = useTranslation()
  const trend = getBehaviorTrend(row)
  const prior = t("adminDashboard.priorPeriodCount", {
    value: row.prior_item_count.toLocaleString("en-US"),
  })

  return (
    <span title={prior}>
      {trend.kind === "new" && t("adminDashboard.behaviourTrendNew")}
      {trend.kind === "same" && t("adminDashboard.behaviourTrendSame")}
      {(trend.kind === "up" || trend.kind === "down") && (
        <>
          <span aria-hidden="true">{trend.kind === "up" ? "▲" : "▼"}</span>
          <Box component="span" sx={visuallyHiddenSx}>
            {t(
              trend.kind === "up"
                ? "adminDashboard.trendUp"
                : "adminDashboard.trendDown",
            )}
          </Box>{" "}
          {trend.percent}%
        </>
      )}
      {/* The hover title isn't reachable by keyboard or screen readers */}
      <Box component="span" sx={visuallyHiddenSx}>
        {prior}
      </Box>
    </span>
  )
}

export default BehaviorTrend
